import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { clearSelectedFilters } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const FilterTags = (({facetFilters, searchFacetChange, navigationTheme}) => {
    const selectedFacetGroup = facetFilters.filter(filter => filter.selectedOptions.length>0);
    const selectedFacetOption = selectedFacetGroup.reduce((accumulator, group) => {
        if (!group) {
            return accumulator;
        }
        const {options, selectedOptions} = group;
        const groupOptions = options.filter(option => selectedOptions.includes(option.id)).map(option=>({...option, group}));
        return [
            ...accumulator,
            ...groupOptions
        ];
    }, []);
    const dispatch = useDispatch()
    
    return ( selectedFacetGroup.length === 0 ? null :
        <div className="category-filters">
            <div className="category-filters__filters">
                {selectedFacetOption && selectedFacetOption.map((option, index) =>
                    <span onClick={event => searchFacetChange(option.group, option)} key={`group-${index}`}> {option.label} <i className="ph-x"></i></span>
                )}
            </div>
            {navigationTheme === 'category' &&
                <span className='show-for-large'>
                    <span> {translate('search.yourfilter')} : </span>
                    {selectedFacetOption && selectedFacetOption.map((option, index) =>
                        <span className="selected-filter__tag" onClick={() => searchFacetChange(option.group, option)} key={`option-${index}`}> {option.label} </span>
                    )}
                </span>
            }
            <a className="clear-filter" onClick={() => dispatch(clearSelectedFilters())}>{translate("filter-tags.clear-all")}</a>
        </div>
)})

export default FilterTags;